export function formatMessageTimestamp(isoTimestamp: string): string {
  if (!isoTimestamp) return ''
  const date = new Date(isoTimestamp)
  const now = new Date()
  const time = date.toLocaleTimeString('es-CR', { hour: '2-digit', minute: '2-digit', hour12: false })
  const isToday = date.toDateString() === now.toDateString()
  if (isToday) return time
  const day = date.toLocaleDateString('es-CR', { day: '2-digit', month: '2-digit' })
  return `${day} ${time}`
}

export function timeAgo(isoTimestamp: string): string {
  if (!isoTimestamp) return ''
  const seconds = Math.max(0, (Date.now() - new Date(isoTimestamp).getTime()) / 1000)

  if (seconds < 10) return 'ahora mismo'
  if (seconds < 60) return `hace ${Math.floor(seconds)} s`
  const minutes = seconds / 60
  if (minutes < 60) return `hace ${Math.floor(minutes)} min`
  const hours = minutes / 60
  if (hours < 24) return `hace ${Math.floor(hours)} h`
  const days = hours / 24
  return `hace ${Math.floor(days)} d`
}
